module.exports = __webpack_public_path__ + "media/images/icons/plus-white-7365a903157ef476057c900a3201f9ac.svg";